import {
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import {
	createPlaceholderDismissedResource,
	type PlaceholderTemplateDismissedFlag,
} from './createPlaceholderDismissedResource.tsx';

export const placeholderConfluenceDummyLinkDismissedResource: RouteResource<PlaceholderTemplateDismissedFlag> =
	createPlaceholderDismissedResource(
		'PLACEHOLDER_CONFLUENCE_DUMMY_LINK_DISMISSED',
		'hasDismissedConfluenceDummyLink',
		'placeholderConfluenceDummyLinkDismissedResource',
	);

export function usePlaceholderConfluenceDummyLinkDismissedResource(): UseResourceHookResponse<PlaceholderTemplateDismissedFlag> {
	return useResource(placeholderConfluenceDummyLinkDismissedResource);
}
